import { Section } from '@flos/react-ui';
import useAppState from '../state/appState';
import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { useContext } from 'react';
import { SubmitContext } from '../context/SubmitContext';
import { pageHasSummaryElement } from '../helpers/pageHasSummaryElement';
import { SubText } from './SubText';

const Header = (props: { pageId: string }) => {
    const formConfig = useAppState((state) => state.formConfig);
    const { isRedirecting } = useContext(SubmitContext);

    const { pageId } = props;

    const pageIndex = formConfig?.pages.findIndex((page) => page.pageId === pageId) ?? -1;

    if (!formConfig || pageIndex <= -1 || pageId === undefined) {
        return null;
    }

    const containSummaryPageElement = pageHasSummaryElement(formConfig, pageId);

    const defaultHeader = (formConfig: FormConfig) => {
        const { caption, subText } = formConfig;
        return (
            <>
                <h1 className="u-spacing-stack-xxl">{caption}</h1>
                {subText.length > 0 && <div dangerouslySetInnerHTML={{ __html: subText.join('<br/>') }} />}
            </>
        );
    };

    const summaryHeader = (formConfig: FormConfig) => {
        if (isRedirecting) {
            return null;
        }

        const { caption, subText } = formConfig.pages[pageIndex];

        return (
            <div className="u-spacing-stack-l">
                <h1>{caption}</h1>
                {subText && (
                    <>
                        <SubText SubTextList={subText} />
                    </>
                )}
            </div>
        );
    };

    return (
        <Section className="u-text-center" noSpaceAbove style={{ paddingBottom: 0 }}>
            {!containSummaryPageElement ? <>{defaultHeader(formConfig)}</> : <>{summaryHeader(formConfig)}</>}
        </Section>
    );
};

export default Header;
